import axios from "axios";
import { resolveApiUrl } from "../assets/GlobalVariables";
import { getSessionId } from "./authService";

const AGENT_SEO_DASHBOARD_PATH = "/api/agent/seo-dashboard/summary";

function summaryUrl() {
  return resolveApiUrl(AGENT_SEO_DASHBOARD_PATH);
}

async function withSessionRequestConfig() {
  const sessionID = await getSessionId();
  if (!sessionID) {
    throw new Error("agent_seo_dashboard_no_session");
  }
  const sid = String(sessionID).trim();
  return {
    headers: {
      "Content-Type": "application/json",
      "X-Session-ID": sid,
    },
    withCredentials: true,
    timeout: 20000,
  };
}

export async function fetchAgentSeoDashboardSummary() {
  const cfg = await withSessionRequestConfig();
  const { data } = await axios.get(summaryUrl(), cfg);
  return data?.summary || null;
}
